import React, { useState, useEffect, useCallback } from "react";
import "./../../App.css";
import "./Transactions.css";
import LeaveRequestPage from "../../v2/pages/Transactions/LeaveRequestPage";

// Refactor Note: This component is now a simple wrapper that renders the LeaveRequestPage.
// All the logic has been shared and moved on corresponding folders in the v2 structure for better organization and maintainability.

function Leave({ user, userAccess, isHideSideMenu }) {

  return (
    <LeaveRequestPage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>
  );
}

export default Leave;
